import { Pipe, PipeTransform } from '@angular/core';
import { FeeChargeRow, SubValueOption } from '../../models/fee-config';

export type { SubValueOption };

@Pipe({ name: 'feeOldSubValueLabel', pure: true })
export class FeeOldSubValueLabelPipe implements PipeTransform {
  transform(oldRow: FeeChargeRow | undefined, allOptions: SubValueOption[]): string {
    if (!oldRow?.eventSubValue) return '';
    return allOptions?.find(option => option.value === oldRow.eventSubValue)?.label ?? oldRow.eventSubValue;
  }
}
